import { CommonPageWrapper, HeadingWrapper } from 'admin/components/wrappers';
import CustomBreadCrumb from 'app/components/CustomBreadCrumb';
import { PageMainLabel } from 'app/components/SHLabel';
import styled from 'styled-components';
import Cookies from 'js-cookie';
import DocumentImageDashboard from './DocumentImageDashboard';
import AdminCustomButton from 'app/components/AdminCustomButton';
import { useState } from 'react';

type Props = {};

const DocumentImageManagement = (props: Props) => {
    const userType = Cookies.get('userType');
    const [isAddDocumentImageModalOpen, setIsAddDocumentImageModalOpen] = useState(false);
    const breadCrumbItems = [
        {
            id: '',
            text: userType === 'COACH' ? 'Showyeda coach' : 'Showyeda admin',
            disabled: true,
        },
        {
            id: userType === 'COACH' ? '/coach/settings/' : '/admin/settings',
            text: 'Settings',
        },
        {
            id: userType === 'COACH' ? '/coach/settings/document-image-management' : '/admin/settings/document-image-management',
            text: 'Document Images',
            disabled: true,
        },
    ];

    return (
        <StyledCommonPageWrapper>
            <HeadingWrapper>
                <PageMainLabel>Document Image Management</PageMainLabel>
                <CustomBreadCrumb preData={breadCrumbItems} />
            </HeadingWrapper>
            <HeadingWrapper>
                <AdminCustomButton
                    buttonType="primary"
                    isActive={false}
                    className="fill-button button-style"
                    onClick={() => {
                        setIsAddDocumentImageModalOpen(true);
                    }}
                >
                    Add Document Image
                </AdminCustomButton>
            </HeadingWrapper>
            <MainContent>
                <ContentLayout>
                    <DocumentImageDashboard isAddDocumentImageModalOpen={isAddDocumentImageModalOpen} setIsAddDocumentImageModalOpen={setIsAddDocumentImageModalOpen} />
                </ContentLayout>
            </MainContent>
        </StyledCommonPageWrapper>
    );
};

export default DocumentImageManagement;
const StyledCommonPageWrapper = styled(CommonPageWrapper)`
    .button-style {
        margin-top: 20px;
        button {
        max-width: unset !important;
        width: unset !important;
        }
    }
`;
const MainContent = styled.section`
    margin-top: 19px;
    width: 100%;
    @media (max-width: 991px) {
        max-width: 100%;
    }
`;

const ContentLayout = styled.div`
    margin-top: 13px;
    width: 100%;
    @media (max-width: 991px) {
        max-width: 100%;
    }
`;